import React from 'react';
import Hero from './Hero';
import CouponCards from './CouponCards';
import HowItWorks from './HowItWorks';
import Wallet from './Wallet';
import FAQ from './FAQ';
import Banner from './Banner';
import RedeemFloatingButton from './RedeemFloatingButton';

function Home({ onNavigate }) {
  return (
    <main>
      <Hero onNavigate={onNavigate} />
      <CouponCards />
      <HowItWorks />
      <Wallet />
      <FAQ />
      <Banner onNavigate={onNavigate} />
      <RedeemFloatingButton onNavigate={onNavigate} />
    </main>
  );
}

export default Home;
